const state = {
  versions: {
    list: []
  }
}

const mutations = {
  VERSIONS_SET_SIMPLE_LIST(state, list) {
    state.versions.list = list
  },
}

const actions = {
  setList: ({ commit }, list) => commit('VERSIONS_SET_SIMPLE_LIST', list),
}

const getters = {
  list: state => state.versions.list
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
